export const waterSystemType = {
  'C': 'Community',
  'NP': 'Non-Public',
  'NC': 'Non-Community',
  'NTNC': 'Non-Transient',
  '': 'Unknown'
};

export const waterSystemRating = {
  'A': 'Approved',
  'C': 'Corrective Action',
  'N': 'Not Approved',
  '': ''
};

export const waterSystemStatus = {
  'A': 'Active',
  'I': 'Inactive',
  'P': 'Proposed',
  '': ''
};

export const activityType = {
  'AB': 'Abandoned',
  'CN': 'Contamination',
  'IU': 'In Use - Not Approved',
  'MN': 'Maintenance/Repair',
  'NU': 'Not Used for Drinking',
  'OP': 'Op Issued - Check',
  'QL': 'Quality/Quantity Problem',
  'RL': 'Replaced',
  'SD': 'Sold/Transfered',
  'EM': 'Emergency',
  '': ''
};

export const availabilityType = {
  'P': 'Permanent',
  'I': 'Interim',
  'O': 'Other',
  'S': 'Seasonal',
  'E': 'Emergency',
  '': ''
};

export const sourceType = {
  'CC': 'Consecutive Connection',
  'CH': 'Common Headers',
  'CS': 'Cistern',
  'CW': 'Clear Well',
  'DS': 'Dist System/Zone',
  'IG': 'Infiltration Gallery',
  'IN': 'Intake',
  'NN': 'Non-Piped, Non-Purchased',
  'NP': 'Non-Piped, Purchased',
  'OT': 'Other',
  'PC': 'Pressure Control',
  'PF': 'Pump Facility',
  'SI': 'Surface Impoundment',
  'SP': 'Spring',
  'SS': 'Sampling Station',
  'ST': 'Storage',
  'TM': 'Transmission Main (Manifold)',
  'TP': 'Treatment Plant',
  'WL': 'Well',
  'WH': 'Well Head',
  'RS': 'Reservoir',
  'RC': 'Roof Catchment',
  '': ''
};

export const waterType = {
  'GU': 'Groundwater UDI Surface',
  'GW': 'Groundwater',
  'SW': 'Surface-water',
  '': ''
};

export const frequencyType = {
  '1T': 'One Time',
  'WK': 'Weekly',
  'MN': 'Monthly',
  'QT': 'Quarterly',
  '6M': '6 Months',
  'YR': 'Yearly',
  '3Y': '3 Years',
  '6Y': '6 Years',
  '9Y': '9 Years',
  '': ''
};

export const sampleType = {
  'CO': 'CO',
  'RT': 'Routine',
  'RP': 'Repeat',
  'TR': 'TR',
  'TG': 'TG',
  '': ''
};